import { QueryClient } from '@tanstack/react-query';

/**
 * Configuração global do React Query
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Configurações padrão para todas as queries
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 2 * 60 * 1000, // 2 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos
      // Agrupamento de queries com a mesma chave em uma única requisição
      refetchOnMount: false,
    },
  },
});

/**
 * Chaves de consulta para uso consistente em toda a aplicação
 */
export const queryKeys = {
  // Chaves para disponibilidade
  availability: {
    all: ['availability'],
    byDate: (salonId, date) => ['availability', salonId, 'date', date],
    byDateRange: (salonId, startDate, endDate) => 
      ['availability', salonId, 'dateRange', startDate, endDate],
    byServiceAndDate: (salonId, serviceIds, date, excludeAppointmentId = null) => 
      ['availability', salonId, 'services', serviceIds.sort().join(','), 'date', date, excludeAppointmentId],
    byProfessional: (salonId, professionalId, date) => 
      ['availability', salonId, 'professional', professionalId, 'date', date],
    detailedByServiceAndDate: (salonId, serviceIds, date, excludeAppointmentId = null) => 
      ['availability', salonId, 'services', serviceIds.sort().join(','), 'date', date, 'detailed', excludeAppointmentId],
    professionalsByServiceAndDateTime: (salonId, serviceIds, date, time) => 
      ['availability', salonId, 'services', serviceIds.sort().join(','), 'date', date, 'time', time, 'professionals'],
    slotStatus: (salonId, date, time, professionalId, serviceIds, excludeAppointmentId = null) => 
      ['availability', salonId, 'date', date, 'time', time, 'professional', professionalId, 'services', serviceIds.sort().join(','), 'status', excludeAppointmentId],
  },
  
  // Chaves para serviços
  services: {
    all: (salonId) => ['services', salonId],
    byId: (salonId, serviceId) => ['services', salonId, serviceId],
    byCategory: (salonId, categoryId) => ['services', salonId, 'category', categoryId],
  },
  
  // Chaves para profissionais
  professionals: {
    all: (salonId) => ['professionals', salonId],
    byId: (salonId, professionalId) => ['professionals', salonId, professionalId],
    byService: (salonId, serviceId) => ['professionals', salonId, 'service', serviceId],
    availability: (salonId, professionalId, date) => 
      ['professionals', salonId, professionalId, 'availability', date],
  },
  
  // Chaves para agendamentos
  appointments: {
    all: (salonId) => ['appointments', salonId],
    byDate: (salonId, date) => ['appointments', salonId, 'date', date],
    byDateRange: (salonId, startDate, endDate) => 
      ['appointments', salonId, 'dateRange', startDate, endDate],
    byId: (salonId, appointmentId) => ['appointments', salonId, appointmentId],
  },
  
  // Chaves para configurações do salão
  salon: {
    config: (salonId) => ['salon', salonId, 'config'],
    categories: (salonId) => ['salon', salonId, 'categories'],
  },
}; 